import React from "react";
import "./neetcoaching.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../footer/Footer";
import mainImg from "../../Assets/faq/mainimg.png";
import dot from "../../Assets/faq/dot.png";
import clarity from "../../Assets/faq/clarity.png";
import practice from "../../Assets/faq/Practice.png";
import Revise from "../../Assets/faq/Revise well.png";
import selfStudy from "../../Assets/faq/Self-study.png";
import regular from "../../Assets/faq/regular.png";
import testPaper from "../../Assets/faq/test papers.png";
import sleep from "../../Assets/faq/sleep.png";
import eat from "../../Assets/faq/eat.png";
import calm from "../../Assets/faq/calm.png";

import person from "../../Assets/testimonial/person.png";
import coma from "../../Assets/testimonial/coma.png";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import { Helmet } from "react-helmet";
import Newnavbar from "../newNavbar/Newnavbar";
import LogoContact from "../logoContact/logoContact";
import { FaWhatsapp } from "react-icons/fa";
import Newenqire from "../Enquire Form/Newenqire";
import { Link } from "react-router-dom";

export default function NeetCoaching() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Best NEET coaching classes in thane | Nayak's Tutorials</title>
        <meta
          name="title"
          content="Expert Faculty: Top NEET Coaching Classes in Thane"
        />
        <meta
          name="description"
          content="Crush the NEET exam! Benefit from expert-led coaching in Thane, strategic test series, and continually updated, target-driven study material. Enroll today!"
        />
        {/* <link
          rel="canonical"
          href="https://nayakstutorials.com/eleven&Twelth/"
        /> */}

        {/* <script type="application/ld+json">
          {`{
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://nayakstutorials.com/"
            }, {
              "@type": "ListItem",
              "position": 2,
              "name": "11 & 12 coaching",
              "item": "https://nayakstutorials.com/eleven&Twelth/"
            }]
          }`}
        </script> */}
      </Helmet>
      {/* <Navbar /> */}

      <div className="wpfloat">
        <LogoContact />
        <Newnavbar />

        <div className="elevenTopDiv">
          <div className="breadcrumbNayak" style={{ marginBottom: "10px" }}>
            <a href="/">Home »</a>
            <a href="/">Our Offerings »</a>
            <a>College »</a>
            <a>NEET Coaching</a>
          </div>

          <div className="elevenMain">
            <div className="elevenLeftDiv">
              <img src={mainImg} />
            </div>
            <div className="elevenRightDiv">
              <h1>NEET Coaching Classes in Thane</h1>
              <p>
                The National Eligibility Entrance Test (NEET) is the most
                crucial medical entrance exam in India for students aspiring to
                pursue MBBS, BDS, and other medical courses in top government
                and private medical colleges. Conducted by the National Testing
                Agency (NTA), NEET is a highly competitive exam that requires a
                strong conceptual foundation, rigorous practice, and expert
                guidance to secure top ranks.<br></br>
                At Nayak’s Tutorials, we provide the best NEET coaching classes
                in Thane, ensuring students get a structured, result-oriented
                learning approach with expert faculty, regular tests, and
                personalized mentorship. Our offline NEET classes in Thane are
                designed to help students build in-depth subject knowledge,
                enhance problem-solving skills, and develop the confidence
                needed to excel in the exam.<br></br>
                At Nayak’s Tutorials, Thane, we ensure that every NEET aspirant
                gets the right guidance, motivation, and academic support to
                achieve their dream of entering a top medical college.<br></br>
                <b>
                  📞 Start Your NEET Journey with the Best NEET Classes in
                  Thane!
                </b>
                <br></br>
                <b>
                  🔗 Enroll Now | 🔗 Contact Us | 🔗 Explore Our Centers | 🔗
                  View JEE Batch
                </b>
                <br></br>
              </p>
            </div>
          </div>
          <div className="ElevenSeconDiv">
            <h2>
              <b>NEET Batch Options:</b>
            </h2>
            <p>
              Our offline NEET classes are designed to provide personalized
              attention, in-depth subject knowledge, and strategic preparation
              to help students excel in NEET 2026-28.
            </p>

            <p>
              <Link to="/ace-40-batch-for-neet-ug-integrated">
                • Regular Batch (40 Students)
              </Link>
              <br />
              <Link to="/g-10-plus-batch-for-neet-ug-integrated">
                • Premium Small Batch (15 Students)
              </Link>
            </p>
          </div>

          <div className="ElevenSeconDiv">
            <h2>Both batches include:</h2>
            <p>
              ✅ Expert faculty with years of NEET coaching experience<br></br>
              ✅ Regular mock tests & NEET pattern practice papers
              <br></br>
              <b>📞 Secure Your Spot in the Best NEET Classes in Thane!</b>
              <br></br>
            </p>
          </div>

          <div className="ElevenSeconDiv">
            <h2>Key Features of NEET Coaching at Nayak’s Tutorials, Thane</h2>
            <p>
              ✔️ Expert Faculty – Learn from IITians, NITians & top medical
              educators.<br></br>
              ✔️ Concept-Based Learning – Strong focus on Physics, Chemistry,
              Zoology & Botany.<br></br>
              ✔️ Comprehensive Study Material – Topic-wise notes, NEET question
              banks & practice sheets.<br></br>
              ✔️ Regular Mock Tests – Weekly & full-length exams to improve
              accuracy & speed.<br></br>
              ✔️ Personalized Mentorship – One-on-one doubt-solving &
              performance tracking.<br></br>
              ✔️ Separate Batches – Regular Batch (40 students) & Premium Small
              Batch (10 students).<br></br>
              ✔️ NEET + Board Exam Integration – Covers NEET-UG & Class 11-12
              syllabus.<br></br>
              ✔️ Scholarships Available – Up to 90% scholarship based on
              NSAT/taleNT2025 exam scores.<br></br>
              ✔️ Structured Offline Coaching in Thane – 6 days a week with
              dedicated self-study & practice sessions.<br></br>
            </p>
          </div>

          <div id="landtestimonialmain" className="cbsetestimonial">
            <h3>
              <b>Student & Parent Testimonials</b>
            </h3>
            <div className="mainTestDiv" id="firstTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial one" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  {" "}
                  Nayak’s Tutorials provided me with the best NEET coaching in
                  Thane. The teachers explained every concept in-depth, and the
                  weekly mock tests helped me improve my accuracy. Thanks to
                  their guidance, I scored well and secured admission to a top
                  medical college!
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
            <div className="mainTestDiv" id="lastTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial two" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  The small batch size at Nayak’s Tutorials made learning easy
                  and interactive. The faculty is highly experienced, and their
                  study material covered everything I needed for NEET-UG. I
                  highly recommend it to anyone serious about cracking NEET.
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
            <div className="mainTestDiv" id="lastTestimonial">
              <div className="testimonialfirst">
                <div style={{ padding: "10px" }} className="testImgDiv">
                  <img src={person} alt="testimonial three" />
                </div>
              </div>
              <div className="testimonialsecond">
                <h5 className="TName">Student</h5>
                <p>
                  I was looking for a reliable NEET coaching institute in Thane
                  for my son, and Nayak’s Tutorials exceeded my expectations.
                  Their mock test series and expert mentoring helped him crack
                  NEET with a great score. We are extremely grateful for their
                  support!
                </p>
              </div>
              <div className="testimonialthird">
                <img src={coma} />
              </div>
            </div>
          </div>
        </div>

        <div className="elevenLastDiv">
          <h3 className="elevenFaq">Frequently Asked Questions (FAQs)</h3>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  1. What is NEET, and why is it important?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                The National Eligibility Entrance Test (NEET) is India’s most
                crucial medical entrance exam for admission into MBBS, BDS, and
                other medical courses in top government and private colleges.
                Conducted by NTA, NEET is mandatory for medical aspirants and
                requires strong conceptual clarity, problem-solving skills, and
                strategic preparation to secure a high rank.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  2. What is the duration of the NEET coaching program?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                At Nayak’s Tutorials, Thane, we offer a 2-year integrated NEET
                coaching program for students in Classes 11 & 12 (2026-28
                batch). This course prepares students for NEET-UG while covering
                the school board syllabus for CBSE, ICSE, and Maharashtra Board.
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  3. What study material do you provide?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                We provide comprehensive NEET study material, including:
                <br></br>
                ✔️ NCERT-based topic-wise notes & practice sheets<br></br>
                ✔️ Previous years’ NEET question papers<br></br>
                ✔️ Shortcut techniques for problem-solving<br></br>
                ✔️ Full-length mock test series<br></br>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  4. What is the batch size?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                We offer two NEET coaching batches in Thane:<br></br>
                🔹 Regular Batch (40 students) – Best for students who prefer
                classroom learning.<br></br>
                🔹 Premium Small Batch (15 students) – Focused, one-on-one
                mentorship with personalized study plans.<br></br>
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <Accordion allowMultipleExpanded={false} allowZeroExpanded>
            <AccordionItem>
              <AccordionItemHeading>
                <AccordionItemButton>
                  5. How are classes conducted at Nayak’s Tutorials?
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                ✔️ Offline Classroom Coaching in Thane for maximum student
                engagement
              </AccordionItemPanel>
            </AccordionItem>
          </Accordion>
          <div className="ElevenSeconDiv">
            <h5>📞 Still have questions? Contact us today!</h5>
          </div>
        </div>
        <Footer />
        <a href="https://wa.me/+917710010044" target="_blank">
          <div className="wpicon">
            <FaWhatsapp id="faWp" size={50} color="white" />
          </div>
        </a>
      </div>
    </>
  );
}
